// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".office_list-module__title--3yzg0{font-weight:600;font-size:16px;line-height:24px;letter-spacing:0px;cursor:pointer}.office_list-module__title--3yzg0:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"title": "office_list-module__title--3yzg0"
};
module.exports = exports;
